import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { Button, Form, Modal } from "react-bootstrap";
import { _delete, _get } from "../utils/APIClient";
import { ConfirmationAlert, getOnlyToken } from "../utils/commonFunctions";
import axios from "axios";
import { set } from "react-hook-form";



export default function WorkFlow() {
  const [search, setSearch] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()
  const [workData,setWorkdata]=useState([])
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(10);
  const [totalCount, setTotalCount] = useState(0);

    const token = getOnlyToken();

  useEffect(() => {
    getWorkFlow()
  }, [])

  const handlePageChange = (page) => {
    getWorkFlow(page, perPage);
  };

  const handlePerPageChange = (newPerPage) => {
    setPerPage(newPerPage);
    getWorkFlow(1, newPerPage);
  };

  const getWorkFlow = async (pageNum = 1, pageSize = 10) => {
    try {
      setLoading(true)
      
            const config = { headers: { Authorization: `Bearer ${token}` } };
      const res = await axios.get(`/ivr/workflow-config/?pagenumber=${pageNum}&perpage=${pageSize}`,config);
      const pagination = res.data.pagination || {};

      if (res.status === 200) {
        setWorkdata(res.data.data || res.data);
        setCurrentPage(pagination.current_page || pageNum);
        setPerPage(pagination.per_page || pageSize);
        setTotalCount(pagination.total_count || 0);
      }

    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Failed to delete workflow");
      setShowErrorModal(true);
    } finally {
      setLoading(false)

    }
  }


  const columns = [
    {
      name: "S.No",
      width: "100px",
      selector: (row, index) => index + 1,
      sortable: true,
    },
    {
      name: "Work Flow Names",
      selector: (row) => row.name,
      sortable: true,
      center:true
    },
    {
      name: "Description",
      selector: (row) => row.description,
    },
    // {
    //   name:'Assign Phone',
    //   selector:(row)=>row.assign_phone,
    //   cell:(row)=>(
    //     <div className="d-flex gap-2">
    //       <div className="d-flex align-items-center gap-2">
    //         <i className="bi bi-telephone-fill"></i>
    //         <p className="mb-0">{row.assign_phone}</p>
    //       </div>
    //     </div>
    //   )
    // },
   {
  name: "Actions",
  width: "150px",
  cell: (row) => (
    <div className="d-flex gap-2 justify-content-center">
      {/* Edit */}
      <button
        className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle border border-secondary "
        title="Edit"
        onClick={() =>
            navigate('/create-workflow', {
              state: { editMode: true,workID:row.id, company_id: row.id }
            })}
        style={{ width: 34, height: 34, backgroundColor: "#7b99b1ff",color:"#fff" }}
      >
        <i className="bi bi-pencil"></i>
      </button>

      {/* Delete */}
      <button
        className="btn btn-sm d-flex align-items-center justify-content-center rounded-circle border border-secondary "
        title="Delete"
        onClick={() => handleDeleteClick(row)}
        style={{ width: 34, height: 34, backgroundColor: "#ee8080ff",color:"#fff" }}
      >
        <i className="bi bi-trash"></i>
      </button>
    </div>
  ),
}

  ];

 

  const customStyles = {
    table: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#FFFFFF",
      },
    },
    headRow: {
      style: {
        backgroundColor: "#2b3544ff",
        borderBottom: "1px solid rgb(70,79,91)",
        minHeight: "45px",
      },
    },
    headCells: {
      style: {
        color: "#fff",
        fontSize: "14px",
        fontWeight: 600,
        borderRight: "1px solid rgb(70,79,91)",
      },
    },
    rows: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#fff",
        minHeight: "48px",
        "&:hover": {
          backgroundColor: "#23263A",
        },
      },
    },
    cells: {
      style: {
        borderBottom: "1px solid rgb(70,79,91)",
        fontSize: "14px",
        color: "#E1E1E1",
      },
    },
    pagination: {
      style: {
        backgroundColor: "#1A1C2B",
        color: "#FFFFFF",
        borderTop: "1px solid rgb(70,79,91)",
      },
      pageButtonsStyle: {
        color: "#FFFFFF !important",
        fill: "#FFFFFF !important",
        "&:hover": {
          backgroundColor: "#2A2D3F",
        },
        "&:disabled": {
          color: "#777 !important",
          fill: "#777 !important",
        },
      },
    },

    noData: {
      style: {
        backgroundColor: "transparent",
        color: "#fff",
        padding: "20px",
      },
    },
  };

  const handleSearch = () => {
    console.log('clicked')
  }

  const handleDeleteClick = (workflow) => {
    ConfirmationAlert(
      `You won't be able to revert this workflow "${workflow.name}"!`,
      'Yes, delete it!',
      () => handleDeleteConfirm(workflow.id)
    );
  }

  const handleDeleteConfirm = async (workflowId) => {
    setLoading(true);
    try {
      await _delete(`ivr/workflow-config/${workflowId}/`);

      await getWorkFlow(currentPage, perPage);

      setShowSuccessModal(true);
      
    } catch (error) {
      setErrorMessage(error.response?.data?.message || "Failed to delete workflow");
      setShowErrorModal(true);
    } finally {
      setLoading(false);
    }
  }


  return (
    <div className="container-fluid py-2" >
      <h3 className="mb-2 fs-2 fw-bold text-success">
        Workflows
      </h3>
      <p className="text-secondary">
        Create, manage, and assign automated workflows
      </p>




      <div className="d-flex gap-2  justify-content-end  align-items-center mb-3">
        <div className="row ">
          <div className="col-md-12 d-flex justify-content-end">
            <div
              style={{ position: "relative", maxWidth: "250px", width: "100%" }}
            >
              <i
                className="bi bi-search"
                style={{
                  position: "absolute",
                  left: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#6c757d",
                  fontSize: "14px",
                }}
              ></i>

              <input
                type="text"
                className="form-control form-control-sm"
                placeholder="Search numbers..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                style={{ paddingLeft: "32px" }}
              />
            </div>

            <Button
              onClick={handleSearch} className="btn-sm mx-2">Search</Button>
          </div>


        </div>
        <Button
          onClick={() =>
            navigate('/create-workflow')
          }

          className="btn-sm px-2 btn-success d-flex align-items-center gap-2  fw-semibold"
        >
          <i className="bi bi-diagram-3"></i>

          Create WorkFlow
        </Button>
      </div>

      {/* Table */}
      <div className="card border-0 shadow-sm" style={{ backgroundColor: "#0f1220" }}>
        {loading ? (
          <div className="text-center py-5">
            <div className="spinner-border text-success" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <DataTable
            columns={columns}
            data={workData}
            pagination
            paginationServer
            paginationTotalRows={totalCount}
            paginationDefaultPage={currentPage}
            paginationPerPage={perPage}
            onChangeRowsPerPage={handlePerPageChange}
            onChangePage={handlePageChange}
            paginationRowsPerPageOptions={[10, 20, 30, 50]}
            customStyles={customStyles}
          />
        )}
      </div>

     {/* Success Modal */}
<Modal
  show={showSuccessModal}
  onHide={() => setShowSuccessModal(false)}
  centered
  backdrop="static"
>
  <Modal.Body className="text-center p-4">
    <div className="mb-3">
      <div
        className="rounded-circle d-inline-flex align-items-center justify-content-center border border-success text-success"
        style={{ width: 56, height: 56 }}
      >
        <i className="bi bi-check-lg fs-3"></i>
      </div>
    </div>

    <h5 className="mb-2 fw-semibold">Deleted successfully</h5>
    <p className="text-muted mb-4">
      The workflow has been removed permanently.
    </p>

    <Button
      variant="outline-success"
      className="px-4"
      onClick={() => setShowSuccessModal(false)}
    >
      Done
    </Button>
  </Modal.Body>
</Modal>

    </div>
  );
}
